import { CheckoutForm } from "../forms/CheckoutForm";

export function CheckoutPopup() {
  return (
    <div className="login-popup">
      <div className="login-popup-inner">
        <CheckoutForm />
      </div>
    </div>
  );
}
